import { ViewportScroller } from '@angular/common';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';;
import { Subscription } from 'rxjs';
import { ScrollableItemDirective } from 'src/app/directives/scrollable-item.directive';
import { DialogService } from 'src/app/services/dialog.service';
import { FilterService } from 'src/app/services/filter.service';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { PopupStatusComponent } from '../popup-status/popup-status.component';
import { DeviceDetectionService } from 'src/app/services/detectipad.service';
import { HoverOverClickComponent } from '../hover-over-click/hover-over-click.component';
import { ConstantsService } from 'src/app/services/constants.service';
import { StaticPopupStatusComponent } from '../../widget/static-list/static-popup-status/static-popup-status.component';

@Component({
    selector: 'app-patient-value-getter',
    templateUrl: './patient-value-getter.component.html',
    styleUrls: ['./patient-value-getter.component.scss'],
    standalone: false
})
export class PatientValueGetterComponent implements ICellRendererAngularComp, OnDestroy {
  params!: ICellRendererParams;
  data:any
  reqSubcription: Subscription[] = []
  api_key:any

  constructor(
    private dialog: MatDialog,
    public filterService: FilterService,
    private newFilterService: NewFilterService,
    private deviceDetectionService: DeviceDetectionService,
    private constantsService: ConstantsService
  ) {}

  agInit(params: ICellRendererParams<any>): void {
    this.data = params
    this.params = params.value
  }

  refresh(): boolean {
    return false;
  }

  statusChanges() {
    // debugger
    if(this.data.selectedStyles) {
      let actionData = this.data.selectedStyles;
      if(actionData.iconsClickEvent) {
        let rowdata = this.data.data
        this.api_key = actionData.iconsClickEvent.iconApi
        let report = "D"
        let patient_status = null
        let case_status = this.data?.colDef?.configuration?.condition_reference_column || "case_status";
        let patientId = this.data?.colDef?.configuration?.isSelectionIconParameter?.[0];
        let reason = this.data?.colDef?.configuration?.api_resp_column_nm;
        let endpoint = this.data?.colDef?.endpoint;
        let resData = {
          report_typ : report,
          api_key : this.api_key,
          patient_status : patient_status,
          patient_case_status : rowdata?.[case_status],
          patient_reason_status : rowdata?.[reason],
          patient_id : rowdata?.[patientId],
          
          data: this.setTheRequiredData(rowdata),
          // actionData: actionData,
          // configuration: this.data?.colDef?.configuration
          api_resp_column_nm: this.data?.colDef?.configuration?.api_resp_column_nm,
          isSelectionIconParameter: this.data?.colDef?.configuration?.isSelectionIconParameter,
          condition_reference_column: this.data?.colDef?.configuration?.condition_reference_column,
          endpoint: this.data?.colDef?.endpoint
        }
        // this.newFilterService.sendData(resData);
        sessionStorage.setItem("patDataStatusChange", JSON.stringify(resData));
        this.filterService.patientStatusCondition = false
        let component:any = this.data.selectedStyles?.staticPopup == true ? StaticPopupStatusComponent : PopupStatusComponent;
        this.dialog.open(component, {disableClose: true,
          width:'400px',
          height: '75',
          data: {endpoint: endpoint || 'pss/get-pss-data'}
        });
      }
    }
  }
  
  popupDataLoad(event:any) {
    event.stopPropagation();
    if(!this.deviceDetectionService.isDesktop) {
      this.filterService.getDataPatientJourneyDataHold.next(this.data)
    }
  }

  noDataLoad() {

  }

  setTheRequiredData(rowdata: any) {
    if (rowdata && Object.keys(rowdata)?.length > 0) {
      let col = this.data?.colDef?.configuration;

      let impColumn = [
        col?.api_resp_column_nm, 
        col?.isSelectionIconParameter?.[0], 
        col?.condition_reference_column, 
        "patient_case_status", 
        "patient_reason_status"
      ];

      // Create a shallow copy to avoid mutating the original grid data
      let clonedData = { ...rowdata };

      // Delete all keys not in impColumn
      Object.keys(clonedData).forEach((key) => {
        if (!impColumn.includes(key)) {
          delete clonedData[key];
        }
      });

      return clonedData;
    }
    return rowdata;
  }

  ngOnDestroy() {
    this.reqSubcription.forEach((res: any) => res.unsubscribe());
  }

  onLongPress(): void {
    if(this.data.column?.colId == 'current_status') {
      this.filterService.getDataPatientJourneyDataHold.next(this.data)
    }
  }
}